var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border_dark"
  }, [_c('div', {
    staticClass: "color_blue",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("  " + _vm._s(_vm.$t('packingb2b.boxContentDetails')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "float": "right",
      "margin-left": "auto"
    }
  }, [_vm._v("\n      Total Qty:" + _vm._s(_vm.qty) + "\n    ")])]), _vm._v(" "), _c('div', _vm._l((_vm.box), function(boxitem) {
    return _c('div', {
      key: boxitem,
      staticClass: "form-group"
    }, [_c('single-box-item', {
      attrs: {
        "boxdata": boxitem
      }
    })], 1)
  }))])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9a46ced6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a46ced6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common_components/boxTable.vue
// module id = 2075
// module chunks = 0